import React from 'react';
import { Layout } from 'antd';
import { IntercomProvider } from 'react-use-intercom';
import FallbackUI from 'components/ErrorFallbackUI';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback(this.state.error);
    }

    return this.props.children;
  }
}

const ErrorBoundaryWrapper = ({ children }) => {
  const renderFallback = (error) => (
    <IntercomProvider appId={process.env.REACT_APP_INTERCOM_APP_ID} autoBoot={true}>
      <Layout>
        <FallbackUI />
      </Layout>
    </IntercomProvider>
  );

  return <ErrorBoundary fallback={renderFallback}>{children}</ErrorBoundary>;
};

export default ErrorBoundaryWrapper;
